import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { t } from '@lingui/macro'

import Grid from '@mui/material/Grid'

import AudioRecordingTable, { AudioRecordingData, AudioRecordingTableProps } from '@/components/ui/tables/AudioRecordingTable'
import StatInput from '@/components/ui/inputs/StatInput'
import BiologicalSection, { BiologicalData } from '@/components/ui/sections/BiologicalSection/BiologicalSection'
import { labelToTranslationKey } from '@/pages/diagnostic/components/Mesures'
import { useIsMobile } from '@/hooks/useSizeBreakpoints'
import CommentField from '../../diagnostic/components/CommentField'
import SelectInput from '@/components/ui/inputs/SelectInput'
import { MeasurementUnitSystem, useMeasurementUnitSystem } from '@/hooks/useMeasurementUnitSystem'
import { parseMeasurementValue, toMeasurementUnit } from '@/utils/unit-system'

type VitalDataProps = Pick<AudioRecordingTableProps, 'onDeleteAnnotation' | 'onUpdateAnnotation'> & {
  comment: string
  mesures: Array<{ label: string; order: number; unit: string; value: string }>
  recordingFiles: AudioRecordingData[]
  biologicalTests: BiologicalData[]
  onCommentChange: (comment: string) => void
  commentEditing: boolean
}

export default function VitalData(props: VitalDataProps) {
  const { comment, mesures, onDeleteAnnotation, onUpdateAnnotation, recordingFiles, biologicalTests, commentEditing, onCommentChange } = props
  const i18next = useTranslation()
  const isMobile = useIsMobile()

  const { unitSystem, setUnitSystem } = useMeasurementUnitSystem()

  return (
    <Grid container spacing={2}>
      <Grid item xs={4} md={2}>
        <SelectInput
          fullWidth
          label={t`Unit system`}
          options={[
            { label: t`Metric`, value: 'metric' },
            { label: t`Imperial`, value: 'imperial' },
          ]}
          value={unitSystem}
          onChange={(e) => setUnitSystem(e.target.value as MeasurementUnitSystem)}
        />
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid container item xs={12} md={6} spacing={2}>
          {_.map(mesures, (mesure, index) => (
            <Grid key={`${mesure.label} - ${index}`} item xs={isMobile ? 6 : 4}>
              <StatInput
                fontSize="large"
                label={`${i18next.t(labelToTranslationKey(mesure.label))} ( ${toMeasurementUnit(mesure.unit, unitSystem)} )`}
                readOnly
                value={parseMeasurementValue(mesure.unit, mesure.value, unitSystem)}
              />
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12} md={6}>
          <CommentField comment={comment} onCommentChange={onCommentChange} readOnly={!commentEditing} />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <AudioRecordingTable data={recordingFiles} onDeleteAnnotation={onDeleteAnnotation} onUpdateAnnotation={onUpdateAnnotation} />
      </Grid>
      <Grid item xs={12}>
        <BiologicalSection data={biologicalTests} />
      </Grid>
    </Grid>
  )
}
